const styles = theme => ({
  deletingPostDialog: {
    zIndex: 1301
  },
  dialogPaper: {
    width: "100%",
    maxWidth: 800
  },
  dialogContent: {
    padding: theme.spacing(2),
    paddingTop: [theme.spacing(2), "!important"]
  },
  dialogActions: {
    padding: theme.spacing(2),
    paddingTop: 0,
    margin: 0
  },
  textExplanation: {
    color: theme.palette.primary.default
  },

  cancelButton: {
    color: [theme.palette.primary.default, "!important"]
  },
  deleteButton: {
    marginLeft: theme.spacing(2),
    backgroundColor: "red",
    "&:hover": {
      backgroundColor: "red"
    }
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/dialogs/DeletingPost/styles.js